import { render, staticRenderFns } from "./index.html?vue&type=template&id=ecabde20&scoped=true&external"
import script from "./PheDuyet.vue?vue&type=script&lang=js"
export * from "./PheDuyet.vue?vue&type=script&lang=js"
import style0 from "./PheDuyet.vue?vue&type=style&index=0&id=ecabde20&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecabde20",
  null
  
)

export default component.exports